import { GetProjectDto } from '../common/pokCore/autogenerated/pokApiClient';

export const buildProjectLabel = (project?: GetProjectDto) => {
  if (project) {
    return `${project.name} (${project.number})`;
  }

  return '-';
};
